import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import DeerFence from "@/pages/DeerFence";

export const Route = createFileRoute("/_public/services/deer-fence")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Deer Fence Installers | Modern Fence Install", "Professional deer fence installation for homes, gardens and larger properties. Tall physical exclusion, dark low-visibility mesh, gates planned for your terrain. Get a ballpark price in about a minute.", "/services/deer-fence", false),
  component: DeerFence,
});
